import { ActionTypes } from '../constants/SettingConstants';
import apiRequest from 'lib/apiRequest';
import { dispatcher } from 'lib/Dispatcher';

const SettingsActions = {
  // TODO make void
  loadSettings(): Promise<void> {
    return apiRequest('/settings', 'GET', {}).then((settings) => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_SETTINGS,
        settings,
      });

      return settings;
    });
  },

  getGeo() {
    return apiRequest('/settings/geo', 'GET', {});
  },
};

export default SettingsActions;
